import { Component } from '@angular/core';
import { DomSanitizer, Title } from "@angular/platform-browser";
import { MatIconRegistry } from "@angular/material/icon";
import { AuthService } from '../../_import/auth.service';
import { SVG_ICONS } from './svg-icons';
import { environment } from 'src/environments/environment';

import { TranslateService } from "@ngx-translate/core";
import { BffAuthService } from 'src/app/_services/auth/auth.service';
import { AuthenticationService } from 'src/app/_services';
@Component({
  selector: 'telio-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  pageDetails: any = {};
  appTitle = environment.branding.title;
  currentApplicationVersion = environment.appVersion;
  loginScreenDetails: any = {};
  telioEVBaseDetails = {
    "logo": "assets/images/logo_white.png",
    "version": environment.appVersion, // missing from API
    "app_title": environment.branding.title,
    "app_desc": "One Stop Destination for SaaS and Electric Vehicle Charging management solution provider.",
    "browser_support_desc": "IE no longer supported. Suggested Edge or Chrome for best performance.",
    "main_color": "#206BB7",
    "primary_button_bg": "#206BB7",
    "secondary_button_bg": "#3BB96C",
    "third_button_bg": "#A8A8A8",
    "button_text_color": "#FFFFFF",
    "button_text": "Login",
    "bg_image_url": "assets/images/banner/desktop.png", // missing from API
    "tenant_type": "0",
    "fav_icon_url": "assets/images/telioevfavicon.png",
    "copyright_desc":"Copyright © 2023 TelioEV | All Rights Reserved",
  };
  isPoweredBy = false;

  constructor(private matIconRegistry: MatIconRegistry,
    readonly title: Title,
    private domSanitizer: DomSanitizer,
    private authService: AuthService,
    private authenticationService:AuthenticationService,
    public translate: TranslateService,
    readonly auth: BffAuthService) {

    const svgIconPath = '../assets/images/';
    SVG_ICONS.forEach(svgIcon => {
      if (!!svgIcon.name && !!svgIcon.filename) {
        this.matIconRegistry.addSvgIcon(
          svgIcon.name,
          this.domSanitizer.bypassSecurityTrustResourceUrl(svgIconPath + svgIcon.filename)
        );
      }
    });
    this.auth.getLoginScreenDetails().subscribe(res => {
      if (!!res) {
        this.pageDetails = res;
        this.isPoweredBy = res.tenant_type == '2';
        this.setDefaultDetails();
      } else {
        this.setDefaultDetails();
      }
    }, err => {
      this.setDefaultDetails();
    })
  }

  setDefaultDetails() {
    this.loginScreenDetails = {
      logo: !!this.pageDetails.logo ? this.pageDetails.logo : this.telioEVBaseDetails.logo,
      version: !!this.pageDetails.version ? this.pageDetails.version : this.telioEVBaseDetails.version,
      app_title: !!this.pageDetails.app_title ? this.pageDetails.app_title : this.telioEVBaseDetails.app_title,
      app_desc: !!this.pageDetails.app_desc ? this.pageDetails.app_desc : this.telioEVBaseDetails.app_desc,
      browser_support_desc: !!this.pageDetails.browser_support_desc ? this.pageDetails.browser_support_desc : this.telioEVBaseDetails.browser_support_desc,
      main_color: !!this.pageDetails.main_color ? this.pageDetails.main_color : this.telioEVBaseDetails.main_color,
      primary_button_bg: !!this.pageDetails.primary_button_bg ? this.pageDetails.primary_button_bg : this.telioEVBaseDetails.primary_button_bg,
      secondary_button_bg: !!this.pageDetails.secondary_button_bg ? this.pageDetails.secondary_button_bg : this.telioEVBaseDetails.secondary_button_bg,
      third_button_bg: !!this.pageDetails.third_button_bg ? this.pageDetails.third_button_bg : this.telioEVBaseDetails.third_button_bg,
      fav_icon_url: !!this.pageDetails.favicon ? this.pageDetails.favicon : this.telioEVBaseDetails.fav_icon_url,
      bg_image_url: !!this.pageDetails.bgImage ? this.pageDetails.bgImage : this.telioEVBaseDetails.bg_image_url,
      copyright_desc: !!this.pageDetails.copyright_desc ? this.pageDetails.copyright_desc : this.telioEVBaseDetails.copyright_desc
    }
    this.setcopyrightLocalStorage(this.loginScreenDetails.copyright_desc)
    document.getElementById('appFavicon').setAttribute('href', this.loginScreenDetails.fav_icon_url);
    this.title.setTitle(this.loginScreenDetails.app_title);
  }

  setcopyrightLocalStorage(copyright: string) {
    localStorage.setItem('copyright', copyright);
  }

  public isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  public login() {
    this.authService.loginWithRedirect();
  }
}